export default "__VITE_ASSET__CtrX0ory__"